var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.nodes)?_c('div',{staticClass:"clearfix"},_vm._l((_vm.nodes),function(node,i){return _c('EditableComponent',{key:'editable-component__' + i,attrs:{"content":node}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }